<template>
    <Header></Header>
        <main> 
            <BreadCrumbs></BreadCrumbs>
            <MainContent :array="arr_data"></MainContent>
        </main>
    <Footer></Footer>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import Footer from "@/components/Footer/Footer.vue";
import BreadCrumbs from "@/components/UI/BreadCrumbs.vue";
import OurBlog from "@/components/Templates/OurBlog.vue";
import FaqBlock from "@/components/Templates/FaqBlock.vue";
import PosotionImgContent from "@/components/Templates/PosotionImgContentRight.vue";
import MainContent from "@/components/PageArticle/MainContent.vue";
import axios from "axios";
export default {
    components: {
        Header,
        Footer,
        BreadCrumbs,
        FaqBlock,
        PosotionImgContent,
        OurBlog,
        MainContent
    },
    data() {
        return {
            arr_data: [],
        }
    },
    methods: {
        getData() {
            let fData = new FormData();
            fData.append("slug", this.$route.params.slug);
            axios.post("/get/blog-post", fData).then(resp => {
                if (resp.data.result == true) {
                this.arr_data = resp.data.blog;
                this.updateTitle(this.arr_data[0].meta_title ? this.arr_data[0].meta_title : "UBL");
                if(this.arr_data[0].meta_description){
                    this.updateMetaDescription(this.arr_data[0].meta_description);
                }
                }
            }).catch(() => {
            }).finally(() => {
            });
        },
        updateTitle(title) {
            let titleTag = document.querySelector("title");
            if (!titleTag) {
                titleTag = document.createElement("title");
                document.head.appendChild(titleTag);
            }
            titleTag.textContent = title || "UBL";
        },

        updateMetaDescription(content) {
            let tag = document.querySelector(`meta[name='description']`);
            if (tag) {
                tag.setAttribute("content", content);
            } else {
                tag = document.createElement("meta");
                tag.setAttribute("name", "description");
                tag.setAttribute("content", content);
                document.head.appendChild(tag);
            }
        }
    },
    mounted () {
        this.getData();
    },
}
</script>

<style scoped>

</style>